export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8766.8f627b33.jpg";